var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7374 10.266C23.7451 13.0669 23.4166 16.1741 21.8487 18.7039C20.2792 21.2335 17.6403 22.9078 14.6836 23.2503C11.7269 23.5927 8.77546 22.5647 6.66944 20.462C4.56516 18.3577 3.53527 15.4062 3.87644 12.4495C4.21604 9.49303 5.88866 6.8525 8.41673 5.28273C10.9463 3.71167 14.0535 3.38158 16.8546 4.38771C16.9911 3.27844 17.4767 2.24379 18.24 1.42969C14.5044 -0.0128356 10.3132 0.348975 6.87914 2.40564C3.44345 4.46389 1.14893 7.99001 0.658585 11.9636C0.166652 15.9372 1.53455 19.9156 4.36565 22.7484C7.19513 25.5795 11.1737 26.9491 15.1472 26.4603C19.1208 25.9714 22.6487 23.6783 24.7084 20.2458C26.7682 16.8117 27.13 12.6204 25.6907 8.88324C24.8782 9.64497 23.8435 10.129 22.7375 10.2654L22.7374 10.266Z",
    fill: "#DFDEE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6177 14.0995L9.77396 11.5366L7.59668 13.9662L11.6592 17.6225C11.9591 17.8875 12.3479 18.0319 12.7479 18.0288H12.8367C13.2715 18.005 13.6778 17.8098 13.9666 17.4845L20.4667 10.1719L18.0291 8.01526L12.6177 14.0995Z",
    fill: "#DFDEE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1226 5.02921C24.1226 7.73811 20.0601 7.73811 20.0601 5.02921C20.0601 2.3203 24.1226 2.3203 24.1226 5.02921Z",
    fill: "#DFDEE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.6ac1f6009894d9bee3ca14ac2da525c0.svg";
export { ForwardRef as ReactComponent };